import { configureStore } from "@reduxjs/toolkit";

import { guideTourReducer } from "../guide-tour/guideTourSlice";

export function createAppStore() {
  return configureStore({
    reducer: {
      guideTour: guideTourReducer,
    },
  });
}

export const store = createAppStore();

export type AppStore = ReturnType<typeof createAppStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
